import { render, staticRenderFns } from "./other-inbound-outbound.vue?vue&type=template&id=3dc31bac&scoped=true&"
import script from "./other-inbound-outbound.vue?vue&type=script&lang=js&"
export * from "./other-inbound-outbound.vue?vue&type=script&lang=js&"
import style0 from "./other-inbound-outbound.vue?vue&type=style&index=0&id=3dc31bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc31bac",
  null
  
)

export default component.exports